import gql from "graphql-tag";

export default gql`
  mutation DestroyAssetDiscussionComment($commentId: ObjectID!) {
    destroyAssetDiscussionComment(commentId: $commentId)
  }
`;
